import * as React from 'react'
import { Link } from 'react-router'
import { compose, pure } from 'recompose'
import { MemberStatus } from '../../../../commons/EditorStatus'
import { Plan } from '../../../../commons/Plan'
import Button from '../../atoms/Button/Button'
import Logo from '../../atoms/Logo/Logo'
import PaidStatusLabel from '../../atoms/PaidStatusLabel/PaidStatusLabel'
import HeaderMenuButton from '../../molecules/HeaderMenuButton/HeaderMenuButton'
import LimitTextField from '../../molecules/LimitTextField/LimitTextField'
import EditorQuizURLModal from '../EditorQuizURLModal/EditorQuizURLModal'
import * as styles from './EditorHeader.css'

interface EditorHeaderProps {
  onChangeProjectTitleText: (data: any) => void
  handleLogOut: () => void
  projectTitle: string
  isModalShow: boolean
  isMenuShow: boolean
  showModal: () => void
  hideModal: () => void
  showMenu: () => void
  hideMenu: () => void
  shareParam: string
  status: MemberStatus
  plan: Plan
  expireDate: string
  handleChangeProjectStarted: (input: boolean) => void
  isStarted: boolean
  handleClickOpenPresentationWindow: () => void
  handleDownloadRankingData: () => void
  isFetchableRankingData: boolean
}

const EditorHeader: React.FunctionComponent<EditorHeaderProps> = ({
  projectTitle,
  onChangeProjectTitleText,
  handleLogOut,
  isModalShow,
  isMenuShow,
  showModal,
  hideModal,
  showMenu,
  hideMenu,
  shareParam,
  plan,
  expireDate,
  handleChangeProjectStarted,
  isStarted,
  handleClickOpenPresentationWindow,
  handleDownloadRankingData,
  isFetchableRankingData
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.logoHeader}>
        <div className={styles.logoHeaderContainer}>
          <Logo />
        </div>
      </div>
      <div className={styles.functionHeader}>
        <div className={styles.functionHeaderContainer}>
          <div className={styles.textContainer}>
            <LimitTextField
              idx={0}
              limitLength={20}
              text={projectTitle}
              handleChange={onChangeProjectTitleText}
              showLimitCount={false}
            />
            <PaidStatusLabel plan={plan} />
          </div>
          <div className={styles.buttonContainer}>
            {plan === Plan.FREE ? (
              <Link className={styles.buttonToSelectPlan} to="/payment">
                <Button isRadius={false}>
                  <p className={styles.buttonText}>プランを購入</p>
                </Button>
              </Link>
            ) : null}
            <div className={styles.buttonRehearsal}>
              <Button isRadius={false} handleClick={showModal}>
                <p className={styles.buttonText}>クイズを再生</p>
              </Button>
            </div>
            <div className={styles.menuButton}>
              <HeaderMenuButton
                showMenu={showMenu}
                hideMenu={hideMenu}
                isMenuShow={isMenuShow}
                plan={plan}
                handleLogOut={handleLogOut}
              />
            </div>
          </div>
        </div>
      </div>
      <EditorQuizURLModal
        shareParam={shareParam}
        plan={plan}
        isModalShow={isModalShow}
        hideModal={hideModal}
        handleChangeAccept={handleChangeProjectStarted}
        isStarted={isStarted}
        expireDate={expireDate}
        handleClickOpenPresentationWindow={handleClickOpenPresentationWindow}
        handleDownloadRankingData={handleDownloadRankingData}
        isFetchableRankingData={isFetchableRankingData}
      />
    </div>
  )
}

export default compose(pure)(EditorHeader)
